<template>
  <div class="app-skeleton" :class="'app-skeleton--' + kind" aria-hidden="true">
    <template v-if="kind === 'bars'">
      <span v-for="(h, i) in bars" :key="i" class="app-skel app-skeleton__bar" :style="{ height: h + '%' }"></span>
    </template>
    <template v-else-if="kind === 'donut'">
      <span class="app-skel app-skeleton__ring"></span>
      <span class="app-skeleton__lines">
        <span class="app-skeleton__row">
          <span class="app-skel app-skeleton__line"></span>
          <span class="app-skel app-skeleton__line app-skeleton__line--end"></span>
        </span>
        <span class="app-skeleton__row">
          <span class="app-skel app-skeleton__line"></span>
          <span class="app-skel app-skeleton__line app-skeleton__line--end"></span>
        </span>
      </span>
    </template>
    <template v-else-if="kind === 'rows'">
      <span v-for="i in rows" :key="i" class="app-skeleton__row app-skeleton__row--list">
        <span class="app-skel app-skeleton__line"></span>
        <span class="app-skel app-skeleton__line app-skeleton__line--end"></span>
      </span>
    </template>
    <span v-else class="app-skel app-skeleton__block"></span>
  </div>
</template>

<script>
// Skelett für den Ladezustand (Kundenwunsch 12.10.2026): graue Formen in der Gestalt des späteren Inhalts mit
// Schimmer-Animation (.app-skel, bedienelemente.css; bei reduzierter Bewegung ruhig). Nur Anzeige (aria-hidden); die
// Statusmeldung „Wird geladen …“ setzt der Behälter (z. B. AppPanel).
// kind: 'bars' (Säulendiagramm), 'donut' (Ring mit zwei Wertzeilen), 'rows' (Liste mit rows Zeilen), 'block' (Fläche,
// z. B. Karte). Füllt den Behälter (Flex).
// feste Höhen in Prozent: wirkt wie ein Diagramm, ohne zu flackern
const BARS = [42, 64, 55, 72, 47, 81, 58, 67, 44, 74, 61, 52, 78, 63, 50, 69, 57, 76, 46, 65, 54, 71, 60, 83];

export default {
  name: 'AppSkeleton',
  props: {
    kind: { type: String, default: 'block' },
    rows: { type: Number, default: 3 }
  },
  data() {
    return { bars: BARS };
  }
};
</script>
